import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { injectIntl } from 'react-intl';

import { Toggle, Links, Link, LinkItem, MainLink, CategoryLink } from './togglableCategory.styles';
import { getField } from '../../../utils/cmsData';
import { accessibleClickHandler, ariaLiveHandler } from '../../../utils/accessibility';
import messages from './togglableCategory.messages';

class TogglableCategory extends PureComponent {
  static propTypes = {
    category: PropTypes.object,
    intl: PropTypes.object.isRequired,
    isOpen: PropTypes.bool,
    onToggle: PropTypes.func.isRequired,
  };

  get hasSubcategories() {
    return !!getField('subcategories', this.props.category);
  }

  toggleOpen = () => {
    if (this.hasSubcategories) {
      this.props.onToggle(!this.props.isOpen);
    }
  };

  renderSubcategories = () => {
    const categories = getField('subcategories', this.props.category) || List();

    return (
      <Links>
        {categories.map(category => (
          <LinkItem key={getField('name', category)}>
            <Link url={getField('categoryPageUrl', category) || '/'}>
              {getField('name', category)}
            </Link>
          </LinkItem>
        ))}
      </Links>
    );
  };

  render() {
    const category = this.props.category;

    return (
      <Fragment>
        <CategoryLink>
          <MainLink url={getField('categoryPageUrl', category)}>
            {getField('name', category)}
          </MainLink>

          {this.hasSubcategories && (
            <Toggle
              aria-label={this.props.intl.formatMessage(messages.toggle)}
              aria-expanded={this.props.isOpen}
              {...accessibleClickHandler(this.toggleOpen)}
              isOpen={this.props.isOpen}
              aria-live={ariaLiveHandler()}
            />
          )}
        </CategoryLink>

        {this.props.isOpen && this.renderSubcategories()}
      </Fragment>
    );
  }
}

export default injectIntl(TogglableCategory);
